import React, { useEffect, useState, useCallback } from 'react';
import { useHistory, useLocation, useParams } from 'react-router-dom';
import Tab from '@mui/material/Tab';
import TabContext from '@mui/lab/TabContext';
import TabList from '@mui/lab/TabList';
import TabPanel from '@mui/lab/TabPanel';
import Settings from '../../assets/Settings.png';
import PersonalDetails from './PersonalDetails';
import PlaylistTable from '../../components/PlaylistTable';
import NavBar from '../../components/NavBarSearchSong';
import { userActions } from '../../actions';
import { formatDateToDisplay } from '../../utils';
import { CircularProgress } from '@mui/material';
import Button from '../../components/Button';
import { playlistActions } from '../../actions';
import { playlistStore } from '../../store';

const UsersVersionTwoDetail = () => {
  const history = useHistory();
  const { user } = useParams();
  const [isLoading, setIsLoading] = useState(true);
  const [userData, setUserData] = React.useState([]);
  const [rowData, setRowData] = useState([
    {
      id: 1,
      playlistImg: '',
      result: 1,
      date: '',
      name: 'Playlist',
      action: '',
    },
  ]);
  const [addPopupOpen, setAddPopupOpen] = useState(false);
  const [selectedUnlimited, setSelectedUnlimited] = useState([]);
  const [adding, setAdding] = useState(false);

  // Zustand Store
  const { unlimitedPlaylists, setUnlimitedPlaylists } = playlistStore((state) => {
    return {
      removeUnlimitedPlaylist: state.removeUnlimitedPlaylist,
      removeRadioPlaylist: state.removeRadioPlaylist,
      addUnlimitedPlaylists: state.addUnlimitedPlaylists,
      addRadioPlaylists: state.addRadioPlaylists,
      unlimitedPlaylists: state.unlimitedPlaylists,
      radioPlaylists: state.radioPlaylists,
      setUnlimitedPlaylists: state.setUnlimitedPlaylists,
    };
  });

  // Get Query Params from the URL
  const location = useLocation();
  const queryParams = new URLSearchParams(location.search);
  const active_tab = queryParams.get('active');

  const [value, setValue] = React.useState(active_tab ? active_tab : 'personaldetail');

  const handleChange = (event, newValue) => {
    history.push(`/users/2.0-users/${user}?active=${newValue}`);
    setValue(newValue);
  };

  useEffect(() => {
    setIsLoading(true);
    (async () => {
      const response = await userActions.fetchAllUsersById(user);
      setUserData(response?.data);
      setIsLoading(false);
    })();
  }, []);

  const refetchUser = useCallback(async () => {
    const response = await userActions.fetchAllUsersById(user);
    setUserData(response?.data);
  }, [user]);

  useEffect(() => {
    setIsLoading(true);
    const InitialPlaylistData = userData?.playlists?.map((row, index) => ({
      id: row.id,
      playlistImg: row.thumbnail_img ? `${process.env.REACT_APP_MEDIA_URL}/${row.thumbnail_img}` : '',
      result: index + 1,
      created_at: row.created_at,
      name: row.name,
      action: row.action,
    }));
    if (InitialPlaylistData) {
      setRowData(InitialPlaylistData);
      setIsLoading(false);
    }
  }, [userData]);

  const handleOpenAdd = async () => {
    if (!unlimitedPlaylists.length) {
      setAdding(true);
      const fetchedData = await playlistActions.fetchAllPlaylist({ type: 'UNLIMITED' });
      setUnlimitedPlaylists(fetchedData);
      setAdding(false);
    }
    setSelectedUnlimited([]);
    setAddPopupOpen(true);
  };

  return (
    <>
      <NavBar
        data="User Version Two Detail"
        icon={Settings}
        currentRouteName={userData?.user?.name}
        breadcrumbsPath={[{ name: 'Users' }, { name: '2.0 Users', link: '/users/2.0-users' }]}
      />
      <TabContext value={value}>
        <div className="tab-wrapper">
          <TabList
            onChange={handleChange}
            aria-label="lab API tabs example"
            className="forplay-tab"
            sx={{
              marginBottom: '40px',
              marginTop: '24px',
              '& .MuiTabs-flexContainer': {
                columnGap: '10px',
              },
              '& .MuiTab-root': {
                fontFamily: 'Poppins',
                fontWeight: '600',
                fontSize: '12px',
                lineHeight: '16px',
                textTransform: 'capitalize',
                paddingInline: '16px',
              },
              '& .MuiTab-root.Mui-selected': {
                color: '#6B3EB4',
              },
              '& .MuiTabs-indicator': {
                backgroundColor: '#6B3EB4',
              },
            }}
          >
            <Tab label="PersonalDetail" value="personaldetail" />
            <Tab label="PrivatePlaylist" value="privateplaylist" />
          </TabList>
          {/* {value === 'privateplaylist' && (
            <div style={{ display: 'flex', justifyContent: 'flex-end', padding: '0 16px 16px 0' }}>
              <Button
                style={{
                  backgroundColor: '#6900af',
                  color: '#fff',
                  borderColor: '#6900af',
                }}
                className="round_btn"
                onClick={() => {
                  handleOpenAdd();
                }}
              >
                Add Playlist
              </Button>
            </div>
          )} */}
        </div>

        {isLoading ? (
          <div style={{ margin: 'auto', width: '100%', display: 'flex', justifyContent: 'center', alignItems: 'center' }}>
            <CircularProgress />
          </div>
        ) : (
          <div className="content">
            <TabPanel sx={{ padding: 0, overflow: 'hidden', flex: 1 }} value="personaldetail">
              <PersonalDetails userData={userData?.user} />
            </TabPanel>
            <TabPanel sx={{ padding: 0, overflow: 'hidden', flex: 1 }} value="privateplaylist">
              <PlaylistTable
                data={rowData}
                playlistType="private"
                userId={user}
                onPlaylistsUpdate={refetchUser}
                showAddButton={false}
                selectedUnlimited={selectedUnlimited}
                setSelectedUnlimited={setSelectedUnlimited}
                adding={adding}
                setAdding={setAdding}
                addPopupOpen={addPopupOpen}
                setAddPopupOpen={setAddPopupOpen}
              />
            </TabPanel>
          </div>
        )}
      </TabContext>
    </>
  );
};

export default UsersVersionTwoDetail;

